<template>
  <div>
    <h3>{{ progressTitle }}</h3>
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        :aria-valuenow="progressAmount"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="{ width: progressAmount }"
      >
        <span class="sr-only">{{ progressAmount }} Complete</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleReg: {
      required: true,
      type: String,
    },
    progress: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      progressTitle: this.titleReg,
      progressAmount: `${this.progress}%`,
    };
  },
};
</script>
